import { Route, RouteComponentProps } from 'react-router-dom';
import { withSentryRouting } from '@sentry/react';
import { CustomTypeListContainerRoute } from 'components/contentTypes/CustomTypeListRoute';
import { CustomTypeEditorRoute } from 'components/contentTypes/CustomTypeEditorRoute';

const SentryEnhancedRoute = withSentryRouting(Route);

interface IProps extends RouteComponentProps<void> {}

export const ContentRoot = (props: IProps) => {
  const { match } = props;

  const renderContentRoot = () => <h1>Content root</h1>;

  return (
    <>
      <SentryEnhancedRoute path="/namespaces" exact component={CustomTypeListContainerRoute} />
      <SentryEnhancedRoute path={match.url} exact render={renderContentRoot} />
      <SentryEnhancedRoute path="/content/:name" exact component={CustomTypeListContainerRoute} />
      <SentryEnhancedRoute path="/content/:name/:id" exact component={CustomTypeEditorRoute} />
    </>
  );
};
